import { Component } from 'react';
import { dispatchTrackingEvent, resetEcommerceTrackingContext, VIEW_ITEM_LIST } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/tracking';

class SearchResultObserver extends Component {
    observer = null;

    trackedItems = new Set();

    componentDidMount() {
        // Aktivan test s verzijom "B", naknadno se prebacuje u verziju "A" ili se uklanja, #64264
        const { isVariantB } = this.props;
        this.observer = new IntersectionObserver(this.handleIntersect, {
            threshold: 0.5,
        });

        const items = isVariantB ? document.querySelectorAll('.single-unit-card') : document.querySelectorAll('.search-result-card__unit');
        items.forEach((item) => this.observer.observe(item));
    }

    componentWillUnmount() {
        if (this.observer) {
            this.observer.disconnect();
        }
    }

    handleIntersect = (entries) => {
        const { trackingData } = this.props;
        const itemsToPush = [];
        entries.forEach((entry) => {
            const { target } = entry;

            if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
                const itemId = target.getAttribute('data-id');

                if (!itemId || this.trackedItems.has(itemId)) return;
                const matchedData = trackingData.find(
                    (item) => String(item.item_id) === String(itemId),
                );
                if (matchedData) {
                    this.trackedItems.add(itemId);
                    itemsToPush.push(matchedData);
                }
            }
        });
        if (itemsToPush.length > 0) {
            resetEcommerceTrackingContext();
            dispatchTrackingEvent(VIEW_ITEM_LIST, {
                ecommerce: {
                    items: itemsToPush,
                },
            });
        }
    };

    render() {
        return null;
    }
}

export default SearchResultObserver;
